import { Controller } from "@hotwired/stimulus"

// "/" anywhere outside a text field opens search, the convention from GitHub, Slack and most docs.
export default class extends Controller {
  static values = { searchUrl: String }

  connect() {
    this.onKeydown = (event) => {
      if (event.key !== "/" || event.metaKey || event.ctrlKey || event.altKey || event.defaultPrevented) return
      if (event.target.closest?.("input, textarea, select, [contenteditable=''], [contenteditable='true']")) return
      event.preventDefault()
      window.Turbo ? window.Turbo.visit(this.searchUrlValue) : window.location.assign(this.searchUrlValue)
    }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }
}
